import { Profile } from 'types/profile'

export type AuthState = {
  session: { id: string; email: string } | null
  profile: Profile | null
}

export const initialState: AuthState = null
